import React, { useState } from "react";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import ClubbieButton from "../../components/ClubbieButton/ClubbieButton";
import { updateTournament } from "../../redux/slices/tournamentSlice";
import { DASHBOARD_STACK } from "../../utils/screenNames";
import { tournamentWizardStepCompleted } from "../../utils/analytics";
import { WIZARD_STEP } from "../../utils/analyticsEvents";
import "./ChooseResultManagement.css";

const ChooseResultManagement = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const selectedTournament = useSelector(
    (state) => state.tournament.selectedTournament
  );
  const [selectedOption, setSelectedOption] = useState(
    selectedTournament?.resultManagement || ""
  );
  const [isLoading, setIsLoading] = useState(false);

  const handleNext = async () => {
    try {
      if (!selectedOption) {
        toast.error("Please select who will manage results");
        return;
      }

      setIsLoading(true);

      const result = await dispatch(
        updateTournament({
          id: selectedTournament?.id,
          updateData: { resultManagement: selectedOption },
        })
      ).unwrap();

      if (result) {
        tournamentWizardStepCompleted({
          stepName: WIZARD_STEP.CHOOSE_RESULT_MANAGEMENT,
          tournamentId: selectedTournament?.id,
        });
        toast.success("Result management preference saved successfully!");
        navigate(DASHBOARD_STACK.CREATE_TOURNAMENT.CHOOSE_VENUE_TYPE);
      } else {
        throw new Error("Failed to update result management preference");
      }
    } catch (error) {
      toast.error(
        error.message || "Failed to update result management preference"
      );
    } finally {
      setIsLoading(false);
    }
  };

  const options = [
    {
      id: "TEAMS",
      name: "Teams",
      description:
        "Teams enter their own results via the Clubbie app. Admins check and verify.",
    },
    {
      id: "REFEREES",
      name: "Admins",
      description: "Competition admins or referees enter the results directly.",
    },
  ];

  return (
    <>
      <div className="input-section">
        <p>Who will manage match results?</p>
        <div
          className="options-container-result-management"
          style={{ height: "100%" }}
        >
          {options.map((option) => (
            <button
              key={option.id}
              className={`option-button ${
                selectedOption === option.id ? "selected" : ""
              }`}
              onClick={() => setSelectedOption(option.id)}
              type="button"
            >
              <div className="option-content">
                <div className="option-radio" />
                <div className="option-details">
                  <span className="option-name">{option.name}</span>
                  <span className="option-description">
                    {option.description}
                  </span>
                </div>
              </div>
            </button>
          ))}
        </div>
      </div>

      <ClubbieButton
        className="next-button"
        onClick={handleNext}
        disabled={isLoading || !selectedOption}
        isLoading={isLoading}
      >
        Next
      </ClubbieButton>
    </>
  );
};

export default ChooseResultManagement;
